import { AlertCircle } from 'lucide-react'

interface Props {
  visible: boolean
  countdown: number
  onExtend: () => void
  onSignout: () => void
}

export default function SessionTimeoutModal({ visible, countdown, onExtend, onSignout }: Props) {
  if (!visible) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" />
      <div className="relative card p-6 max-w-sm w-full space-y-4">
        <div className="flex items-center gap-3">
          <AlertCircle size={24} className="text-amber-500 flex-shrink-0" />
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Session Timeout</h2>
        </div>
        <p className="text-sm text-gray-600 dark:text-gray-300">
          Your session is about to expire due to inactivity.
        </p>
        <p className="text-sm text-gray-600 dark:text-gray-300">
          You will be signed out in{' '}
          <strong className="text-gray-900 dark:text-gray-100">{countdown}</strong> seconds.
        </p>
        <div className="flex gap-2 justify-end">
          <button className="btn-secondary text-sm" onClick={onSignout}>
            Sign Out Now
          </button>
          <button className="btn-primary text-sm" onClick={onExtend}>
            Stay Signed In
          </button>
        </div>
      </div>
    </div>
  )
}
